import api from "../auth/api";
import type {
  GetNotificationsQuery,
  GetNotificationsResponse,
  CreateNotificationRequest,
  CreateNotificationResponse,
  UpdateNotificationRequest,
  UpdateNotificationResponse,
  GetNotificationResponse,
  GetUserNotificationsQuery,
  GetUserNotificationsResponse,
  UnreadCountResponse,
  MarkAsReadResponse,
  MarkAllAsReadResponse,
} from "./notification.type";

// Get notifications list with pagination and filters
export const getNotifications = async (
  query: GetNotificationsQuery = {}
): Promise<GetNotificationsResponse> => {
  const response = await api.get<GetNotificationsResponse>(
    "/notifications",
    {
      params: query,
    }
  );
  return response.data;
};

// Get notification by ID
export const getNotificationById = async (
  id: string
): Promise<GetNotificationResponse> => {
  const response = await api.get<GetNotificationResponse>(
    `/notifications/${id}`
  );
  return response.data;
};

// Create new notification
export const createNotification = async (
  data: CreateNotificationRequest
): Promise<CreateNotificationResponse> => {
  const response = await api.post<CreateNotificationResponse>(
    "/notifications",
    data
  );
  return response.data;
};

// Update notification by ID
export const updateNotification = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateNotificationRequest;
}): Promise<UpdateNotificationResponse> => {
  const response = await api.put<UpdateNotificationResponse>(
    `/notifications/${id}`,
    data
  );
  return response.data;
};

// Delete notification by ID
export const deleteNotification = async (id: string): Promise<void> => {
  await api.delete(`/notifications/${id}`);
};

// User notification APIs

// Get user notifications list
export const getUserNotifications = async (
  query: GetUserNotificationsQuery = {}
): Promise<GetUserNotificationsResponse> => {
  const response = await api.get<GetUserNotificationsResponse>(
    "/notifications/me",
    {
      params: query,
    }
  );
  return response.data;
};

// Get unread notifications count
export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  const response = await api.get<UnreadCountResponse>(
    "/notifications/me/unread-count"
  );
  return response.data;
};

// Mark all notifications as read
export const markAllAsRead = async (): Promise<MarkAllAsReadResponse> => {
  const response = await api.post<MarkAllAsReadResponse>(
    "/notifications/me/read-all"
  );
  return response.data;
};

// Mark single notification as read
export const markNotificationAsRead = async (
  id: string
): Promise<MarkAsReadResponse> => {
  const response = await api.post<MarkAsReadResponse>(
    `/notifications/me/${id}/read`
  );
  return response.data;
};

